import type { RulesStatsRequestRule } from '../api/games';
import type { TicketRule } from '../types/rules';

export function buildRulesStatsPayload(
  ruleRows: TicketRule[],
  options?: { draftInstanceId?: string; draftSettings?: Record<string, string | number | boolean> }
): RulesStatsRequestRule[] {
  return ruleRows
    .filter((r) => r.enabled !== false)
    .map((r) => ({
      instanceId: r.instanceId,
      kind: r.id,
      id: r.id,
      weight: r.weight,
      settings:
        options?.draftInstanceId === r.instanceId && options.draftSettings
          ? options.draftSettings
          : (r.settings ?? {}),
    }));
}
